import ServicePageTemplate from '../services/ServicePageTemplate';
import { seoPageData } from '../../mocks/seoPages';
const TanklessWaterHeatersPage = () => <ServicePageTemplate data={seoPageData['tankless-water-heaters']} />;
export default TanklessWaterHeatersPage;
